module.exports = __webpack_public_path__ + "static/media/aragon56.356c33e7.jpg";